<template>
  <div>
    <div class="page-content__header-description header-texts">
      <h2 style="flex: 1">New Signups</h2>
      <div class="analysis">
        <p style="justify-content: center; align-items: center">
          <span style="text-align: center !important">Analysis</span><br />
          <span>{{ db_param }}: </span>
          <span
            style="
              font-size: 18px;
              font-weight: bold;
              color: #3b83b3;
              margin: 0;
            "
            >{{ analysed_data }}</span
          >
        </p>
      </div>
    </div>
    <div class="select-filter" style="display: flex; margin-right: 8px">
      <select
        class="select-input"
        v-model="db_model"
        @change="handleInput"
        name="selectInput"
        required
      >
        <option disabled selected value="">Please select a column</option>
        <option
          v-for="(item, key) in filter_model"
          :key="key"
          :value="item.model"
        >
          {{ item.output }}
        </option>
      </select>
      <div>
        <input
          type="search"
          name="search"
          id="filter"
          class="select-input"
          @input="searchArray"
          v-model="schQuery"
          placeholder="Search..."
        />

        <!-- Dropdown list for the search results -->
        <ul v-if="filteredResults.length" class="search-dropdown">
          <li
            v-for="(item, index) in filteredResults"
            :key="index"
            @click="selectItem(item)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <!-- Select Filter param -->
      <!-- <select
        class="select-input"
        v-model="db_param"
        @change="handleSearch"
        required
      >
        <option disabled selected value="">Filter by</option>
        <option
          v-for="(value, index) in filter_param"
          :key="index"
          :value="value"
          >{{ value }}</option
        >
      </select> -->
      <DateRangePicker v-model="dateRange" @input="handleDateRangeChange" />
    </div>

    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12">
        <!-- Add this modal component -->
        <div class="modal" v-if="showModal">
          <div class="modal-content">
            <h3>Confirm State Change</h3>
            <p>
              Are you sure you want to change the customer's state to
              {{ selectedNewState }}?
            </p>
            <div class="modal-buttons">
              <button
                class="btn-confirm"
                @click="confirmStateChange"
                :disabled="isUpdatingState"
              >
                <span v-if="isUpdatingState">updating...</span>

                <span v-else>Confirm</span>
              </button>
              <button
                class="btn-cancel"
                @click="cancelStateChange"
                :disabled="isUpdatingState"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>

        <vue-good-table
          :columns="columns"
          :rows="rows"
          :search-options="{
            enabled: true,
            placeholder: 'Search data',
          }"
          :pagination-options="{
            enabled: true,
            perPage: 10,
          }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'createdat', type: 'desc' },
          }"
          :line-numbers="true"
          styleClass="vgt-table striped"
          :isLoading.sync="isLoading"
        >
          <div slot="loadingContent">Loading data... Please wait</div>
          <div slot="emptystate">No data found</div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'firstname'">
              {{ props.row.firstname }}
            </span>
            <span v-else-if="props.column.field == 'lastname'">
              {{ props.row.lastname }}
            </span>
            <span v-else-if="props.column.field == 'phonenumber'">
              {{ props.row.phonenumber }}
            </span>
            <span v-else-if="props.column.field == 'username'">
              {{ props.row.username }}
            </span>
            <span v-else-if="props.column.field == 'createdat'">
              {{ formatDate(props.row.createdat) }}
            </span>
            <span v-else-if="props.column.field == 'state'">
              <select
                class="state-dropdown"
                :value="props.row.state"
                @change="handleStateChange($event, props.row)"
              >
                <option
                  v-for="state in onboardingStates"
                  :key="state"
                  :value="state"
                  :selected="state === props.row.state"
                >
                  {{ state }}
                </option>
              </select>
              <!-- {{ props.row.state || "" }} -->
            </span>
            <span v-else-if="props.column.field == 'location'">
              {{ props.row.location || "" }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import AnimatedSpinnerLoader from "@/components/AnimatedSpinnerLoader.vue";
import DateRangePicker from "@/components/pages/kitchen/date-range-picker";
import CalculatorService from "@/services/calculator.js";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "ListNewCustomers",
  components: {
    "animated-spinner": AnimatedSpinnerLoader,
    DateRangePicker,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  data() {
    return {
      analysed_data: "",
      dateRange: {
        start: new Date(2024, 7, 31),
        end: new Date(),
      },
      schQuery: "",
      db_model: "",
      db_param: "",
      filter_param: [],
      filter_model: [
        {
          id: 1,
          model: "currentPageName",
          output: "Onboarding State",
        },
        {
          id: 2,
          model: "customerRegion",
          output: "Location",
        },
      ],
      columns: [
        {
          label: "First Name",
          field: "firstname",
        },
        {
          label: "Last Name",
          field: "lastname",
        },
        {
          label: "Phone Number",
          field: "phonenumber",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "Location",
          field: "location",
        },
        {
          label: "Onboarding State",
          field: "state",
        },
        {
          label: "Created At",
          field: "createdat",
          sortable: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
          dateOutputFormat: "MMM dd, yyyy HH:mm",
          formatFn: this.formatDate,
        },
      ],
      isLoading: false,
      rows: [],
      showModal: false,
      selectedNewState: "",
      selectedCustomer: null,
      onboardingStates: [
        "BVNCheck",
        "OnboardIPPPaymentSummary",
        "OnboardContractUpload",
        "IPPSelectDevice",
        "Start",
        "AwaitingContract",
      ],
      isUpdatingState: false,
    };
  },
  computed: {
    filteredResults() {
      if (this.schQuery === "") {
        return [];
      }
      const lowerQuery = this.schQuery.toLowerCase();
      return this.filter_param.filter((item) =>
        item.toLowerCase().includes(lowerQuery)
      );
    },
    ...mapGetters(["getUsers"]),
  },
  methods: {
    async selectItem(item) {
      this.db_param = item; // Store the selected item in `db_param`
      this.schQuery = ""; // Clear the search input
      console.log("this.db_param", this.db_param);
      let data = {
        filter_model: this.db_model,
        filter_params: this.db_param,
        start_date: this.dateRange.start,
        end_date: this.dateRange.end,
      };
      const res = await CalculatorService.locationOrStateMetrics(data);
      this.analysed_data = res.Data;
    },
    async handleDateRangeChange(newDateRange) {
      this.dateRange = newDateRange;
      let data = {
        filter_model: this.db_model,
        filter_params: this.db_param,
        start_date: this.dateRange.start,
        end_date: this.dateRange.end,
      };
      const res = await CalculatorService.locationOrStateMetrics(data);
      this.analysed_data = res.Data;
    },
    formatDate(value) {
      return moment(value).format("MMM DD, YYYY hh:mm A");
    },
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    handleInput() {
      if (this.db_model == "customerRegion") {
        this.filter_param = [
          "ikorodu_epe",
          "mainland",
          "lekki",
          "lagos_island_vi",
          "sango_ota_badagry",
          "mowe_ibafo",
          "oyo",
          "ogun",
          "osun",
          "ondo",
          "ekiti",
          "plateau",
          "niger",
          "abuja",
          "nassarawa",
          "benue",
          "kogi",
          "kwara",
          "kano",
          "kaduna",
          "katsina",
          "zamfara",
          "sokoto",
          "jigawa",
          "kebbi",
          "adamawa",
          "bauchi",
          "borno",
          "gombe",
          "taraba",
          "yobe",
          "abia",
          "anambra",
          "ebonyi",
          "enugu",
          "imo",
          "edo",
          "delta",
          "bayelsa",
          "rivers",
          "cross_river",
          "akwa_ibom",
        ];
      } else if (this.db_model == "currentPageName") {
        this.filter_param = [
          "Start",
          "IPPSelectDevice",
          "OnboardIPPPaymentSummary",
          "OnboardLOPaymentSummary",
          "BVNCheck",
          "OnboardOSPaymentSummary",
          "OnboardContractUpload",
        ];
      } else {
        this.filter_param = [];
      }
    },
    init() {
      const HTTP = this.$httpUtils.FASTHTTP;

      let url = `/onboardingstate/signup`;
      //   this.showInitLoading = true;

      HTTP.get(url)
        .then((response) => {
          this.rows = response.data.data;
          //   this.showInitLoading = false;
        })
        .catch((error) => {
          //   this.showInitLoading = false;
          this.showErrorMsg({ message: "Error occurred at our end!" });
        });
    },
    async handleSearch() {
      let data = {
        filter_model: this.db_model,
        filter_params: this.db_param,
        start_date: this.dateRange.start,
        end_date: this.dateRange.end,
      };
      const res = await CalculatorService.locationOrStateMetrics(data);
      this.analysed_data = res.Data;
    },
    handleStateChange(event, customer) {
      this.selectedNewState = event.target.value;
      this.selectedCustomer = customer;
      this.showModal = true;
    },

    async confirmStateChange() {
      this.isUpdatingState = true;
      try {
        const HTTP = this.$httpUtils.FASTHTTP;
        const url = `/onboardingstate/change-state`;
        const response = await HTTP.patch(
          url,
          {
            email: this.selectedCustomer.email,
            state: this.selectedNewState,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("auth")}`,
            },
          }
        );
        if (response.status === 200) {
          // Update the local state
          const customerIndex = this.rows.findIndex(
            (row) => row.email === this.selectedCustomer.email
          );
          if (customerIndex !== -1) {
            this.rows[customerIndex].state = this.selectedNewState;
          }
          this.showSuccessMsg({
            message: "Customer onboarding state updated successfully!",
          });
        }
      } catch (error) {
        this.showErrorMsg({
          message: "Failed to update customer onboarding state",
        });
      } finally {
        this.isUpdatingState = false;
        this.showModal = false;
        this.selectedNewState = "";
        this.selectedCustomer = null;
      }
    },

    cancelStateChange() {
      this.showModal = false;
      this.selectedNewState = "";
      this.selectedCustomer = null;
      // Refresh the table to revert the select back to original value
      this.init();
    },
  },
  async mounted() {
    this.init();
  },
};
</script>

<style scoped>
.analysis {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-right: 25px;
  position: relative;
}

.analysis p {
  color: #333;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 2px;
  margin: 0;
}

.header-texts {
  margin-top: 12px;
  display: flex;
  margin-left: 25px;
}
.select-filter {
  margin-left: 25px;
}
.select-input {
  border: 1px solid #cccccc;
  border-radius: 12px;
  padding: 5px 10px;
  margin-right: 6px;
}
.search-dropdown {
  /* position: absolute;
  top: 100%; 
  left: 0;
  right: 0; */
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 0;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0;
  margin: 0;
  list-style-type: none;
}

/* Style each dropdown item */
.search-dropdown li {
  padding: 8px 12px;
  cursor: pointer;
}

.search-dropdown li:hover {
  background-color: #f0f0f0;
}

.vgt-table.striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
a:hover {
  color: blue;
  text-decoration: underline;
}

.ellipsis_style {
  font-size: 30px;
  color: #1388bd;
}
.pagin_style {
  color: #85878d;
}
.action_delete {
  color: red;
}
.action_delete:hover {
  background-color: red;
  color: whitesmoke;
}
.action_update {
  color: #1388bd;
}
.action_update:hover {
  background-color: #1388bd;
  color: whitesmoke;
}
.el-input__inner {
  border-radius: 10px;
  /* width: 360px; */
  background-color: #eff0f4;
  border-color: #eff0f4;
}
.triangle {
  /* background-color: red; */
  width: 40%;
  margin-left: auto;
  margin-right: auto;
}
.form {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

h4 {
  font-weight: 600;
  color: #6a707e;
  border: none;
  text-align: center;
}

.row {
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-delete {
  padding: 5px;
  color: white;
  border-color: red;
  background: red;
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.button-delete:hover {
  padding: 5px;
  color: white;
  border-color: rgb(146, 1, 1);
  background: rgb(146, 1, 1);
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.red-border {
  border: 2px solid red;
  width: 30px;
}

.button-cancel {
  padding: 5px;
  color: grey;
  border: 1px solid grey;
  background: white;
  width: 49%;
  border-radius: 8px;
}

.button-cancel:hover {
  padding: 5px;
  color: white;
  border: 1px solid grey;
  background-color: #85878d;
  width: 49%;
  border-radius: 8px;
}

table th,
table th span {
  font-size: 0.7em;
}
.onboarding-page {
  height: calc(100vh - 250px);
}
.uk-offcanvas-bar {
  width: 90vw !important;
}
.action_style {
  display: flex;
  gap: 10px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  text-align: center;
}

.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.btn-confirm {
  padding: 8px 16px;
  background-color: #3b83b3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-cancel {
  padding: 8px 16px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.state-dropdown {
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 200px;
}

.state-dropdown:focus {
  outline: none;
  border-color: #3b83b3;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboardingTracker/ListNewCustomers.vue